const compraUnicaContainerSubscriptionDetails = document.getElementById("div-compra-unica-subscription-details");
const compraUnicaRadiobtnSubscriptionDetails = document.getElementById("compra-unica-radiobtn-subscription-details");

const suscripcionContainerSubscriptionDetails = document.getElementById("compra-subscripcion-subscription-details");
const subscripcionRadiobtnSubscriptionDetails = document.getElementById("subscripcion-radiobtn-subscription-details");
const subscriptionsOptionsSubscriptionDetails = document.getElementById("subscription-options-subscription-details");

const textoBtnComprarSubscriptionDetails = document.getElementById("texto-btn-comprar-subscription-details");

const unMesRadiobtnSubscriptionDetails = document.getElementById("subscripcion-1mes-radiobtn-subscription-details");
const dosMesesRadiobtnSubscriptionDetails = document.getElementById("subscripcion-2meses-radiobtn-subscription-details");
const tresMesesRadiobtnSubscriptionDetails = document.getElementById("subscripcion-3meses-radiobtn-subscription-details");

const badgeDescuentoSub1SubscriptionDetails = document.getElementById("savvy-prime-procentaje-descuento1-subscription-details");
const badgeDescuentoSub2SubscriptionDetails = document.getElementById("savvy-prime-procentaje-descuento2-subscription-details");
const badgeDescuentoSub3SubscriptionDetails = document.getElementById("savvy-prime-procentaje-descuento3-subscription-details");

const precioFinalSub1SubscriptionDetails = document.getElementById("savvy-prime-precio-final1-subscription-details");
const precioFinalSub2SubscriptionDetails = document.getElementById("savvy-prime-precio-final2-subscription-details");
const precioFinalSub3SubscriptionDetails = document.getElementById("savvy-prime-precio-final3-subscription-details");

const anchorDetallesProducto = document.getElementById("ver-detalles-producto-anchor-subscription-details");

function resetStylesCompraUnicaSubscriptionDetails() {
    compraUnicaContainerSubscriptionDetails.style.backgroundColor = "rgb(255,255,255)";
    compraUnicaContainerSubscriptionDetails.style.border = "solid rgb(0 0 0 / 30%)";
    compraUnicaContainerSubscriptionDetails.style.borderWidth = "2px 2px 0px 2px";
    compraUnicaContainerSubscriptionDetails.style.borderRadius = "4px 4px 0px 0px";
    compraUnicaContainerSubscriptionDetails.style.padding = "24px 12px";
}

function resetStylesSubscripcionSubscriptionDetails() {
    suscripcionContainerSubscriptionDetails.style.backgroundColor = "rgb(255,255,255)";
    suscripcionContainerSubscriptionDetails.style.border = "solid rgb(0 0 0 / 30%)";
    suscripcionContainerSubscriptionDetails.style.borderWidth = "0px 2px 2px 2px";
    suscripcionContainerSubscriptionDetails.style.borderRadius = "0px 0px 4px 4px";
    suscripcionContainerSubscriptionDetails.style.padding = "24px 12px";
}

function activarStylesCompraUnicaSubscriptionDetails() {
    resetStylesSubscripcionSubscriptionDetails();
    compraUnicaContainerSubscriptionDetails.style.backgroundColor = "rgb(255,245,237)";
    compraUnicaContainerSubscriptionDetails.style.border = "2px solid #FFD54F";
    compraUnicaContainerSubscriptionDetails.style.borderRadius = "4px 4px 0px 0px";
    textoBtnComprarSubscriptionDetails.textContent = "Agregar producto";

    if(subscriptionsOptionsSubscriptionDetails){
        subscriptionsOptionsSubscriptionDetails.style.display = "none";
        unMesRadiobtnSubscriptionDetails.checked = false;
    }
    
}

function activarStylesSuscripcionSubscriptionDetails() {
    resetStylesCompraUnicaSubscriptionDetails();
    suscripcionContainerSubscriptionDetails.style.backgroundColor = "rgb(255,245,237)";
    suscripcionContainerSubscriptionDetails.style.border = "solid #FFD54F";
    suscripcionContainerSubscriptionDetails.style.borderWidth = "2px 2px 0px 2px";
    suscripcionContainerSubscriptionDetails.style.padding = "24px 12px 0px 12px";
    suscripcionContainerSubscriptionDetails.style.borderRadius = "0px 0px 0px 0px";
    textoBtnComprarSubscriptionDetails.textContent = "Agregar suscripción";

    if(subscriptionsOptionsSubscriptionDetails){
        subscriptionsOptionsSubscriptionDetails.style.display = "flex";
        unMesRadiobtnSubscriptionDetails.checked = true;
    }
}

subscripcionRadiobtnSubscriptionDetails.checked = true;
if(subscripcionRadiobtnSubscriptionDetails.checked){
    activarStylesSuscripcionSubscriptionDetails();
    unMesRadiobtnSubscriptionDetails.checked = true;
}

compraUnicaRadiobtnSubscriptionDetails?.addEventListener("click", activarStylesCompraUnicaSubscriptionDetails);
subscripcionRadiobtnSubscriptionDetails?.addEventListener("click", activarStylesSuscripcionSubscriptionDetails);

unMesRadiobtnSubscriptionDetails?.addEventListener("click", ()=>{
    badgeDescuentoSub1SubscriptionDetails.style.display = "block";
    badgeDescuentoSub2SubscriptionDetails.style.display = "none";
    badgeDescuentoSub3SubscriptionDetails.style.display = "none";

    precioFinalSub1SubscriptionDetails.style.display = "block";
    precioFinalSub2SubscriptionDetails.style.display = "none";
    precioFinalSub3SubscriptionDetails.style.display = "none";
});

dosMesesRadiobtnSubscriptionDetails?.addEventListener("click", ()=>{
    badgeDescuentoSub1SubscriptionDetails.style.display = "none";
    badgeDescuentoSub2SubscriptionDetails.style.display = "block";
    badgeDescuentoSub3SubscriptionDetails.style.display = "none";

    precioFinalSub1SubscriptionDetails.style.display = "none";
    precioFinalSub2SubscriptionDetails.style.display = "block";
    precioFinalSub3SubscriptionDetails.style.display = "none";
});

tresMesesRadiobtnSubscriptionDetails?.addEventListener("click", ()=>{
    badgeDescuentoSub1SubscriptionDetails.style.display = "none";
    badgeDescuentoSub2SubscriptionDetails.style.display = "none";
    badgeDescuentoSub3SubscriptionDetails.style.display = "block";

    precioFinalSub1SubscriptionDetails.style.display = "none";
    precioFinalSub2SubscriptionDetails.style.display = "none";
    precioFinalSub3SubscriptionDetails.style.display = "block";
});

document.addEventListener("DOMContentLoaded", function () {
    if (anchorDetallesProducto) {
        anchorDetallesProducto.addEventListener("click", function (event) {
            event.preventDefault();
            
            const targetSection = document.querySelector(anchorDetallesProducto.getAttribute("href"));

            if (targetSection) {
                targetSection.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        });
    }

    const divCompraUnica = document.getElementById('div-compra-unica-subscription-details');
    const divSuscripcion = document.getElementById('compra-subscripcion-subscription-details');

    const radioButton = divCompraUnica.querySelector('#compra-unica-radiobtn-subscription-details');
    const radioButtonSuscripcion = divSuscripcion.querySelector('#subscripcion-radiobtn-subscription-details');

    if (divCompraUnica && radioButton) {
        divCompraUnica.addEventListener('click', function(event) {

            radioButton.click();
        });
    } else {
        if (!divCompraUnica) console.error('No se encontró el div #div_compra_unica');
        if (!radioButton) console.error('No se encontró el radio button .compra-unica-radiobtn-overlay dentro del div');
    }
    if (divSuscripcion && radioButtonSuscripcion) {
        divSuscripcion.addEventListener('click', function(event) {

            radioButtonSuscripcion.click();

        });
    } else {
        if (!divSuscripcion) console.error('No se encontró el div #div_compra_unica');
        if (!radioButtonSuscripcion) console.error('No se encontró el radio button .compra-unica-radiobtn-overlay dentro del div');
    }
});
